import { tokenStore } from '@applyboard/abid-provider';

export async function getAccessToken(failIfNotAuthenticated = true): Promise<string> {
  let tokens;

  try {
    tokens = await tokenStore.loadTokens({
      customRedirectToUrl: undefined,
      allowAnonymous: false,
      disableRedirectOnUnauthorized: true,
    });
  } catch (error) {
    console.error('Failed to get access token', error);
    if (failIfNotAuthenticated) {
      throw error;
    }
  }

  return tokens?.accessToken;
}
